import { GET_ONE_DOCS_FAILED, GET_ONE_DOCS_SUCCESSED } from "../actions/types";
const initialState = {
	docs: {},
	isDone: false,
	isFailed: false
};
export default function(state = initialState, action) {
	switch (action.type) {
		case GET_ONE_DOCS_SUCCESSED:
			return {
				docs: action.payload,

				isDone: true,
				isFailed: false
			};
		case GET_ONE_DOCS_FAILED:
			return {
				isDone: true,
				isFailed: false
			};

		default:
			return state;
	}
}
